/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamTaskEvaluationOutputSubEvaluations } from './oralExamTaskEvaluationOutputSubEvaluations';
import type { OralExamTaskEvaluationOutputOverallFeedback } from './oralExamTaskEvaluationOutputOverallFeedback';
import type { OralExamTaskEvaluationOutputPromptVersion } from './oralExamTaskEvaluationOutputPromptVersion';

/**
 * Oral exam evaluation with per-question dimension grades and feedback.
 */
export interface OralExamTaskEvaluationOutput {
  kind?: 'oral_exam';
  subEvaluations: OralExamTaskEvaluationOutputSubEvaluations;
  overallFeedback?: OralExamTaskEvaluationOutputOverallFeedback;
  promptVersion?: OralExamTaskEvaluationOutputPromptVersion;
}
